export default __webpack_public_path__ + "external-link-square-with-an-arrow-in-right-diagonal.png";